// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { PFixFieldSet } from '../Fields/FieldsImport.js'
export let HistoricalBrokerMessageGroup = function (pfixFieldSet)
{
    PFixFieldSet.call(this, FieldsFactory.HISTORICAL_BROKER_MESSAGE_GROUP, null, pfixFieldSet)
}
HistoricalBrokerMessageGroup.prototype = Object.create(PFixFieldSet.prototype)

HistoricalBrokerMessageGroup.prototype.getMessageID = function ()
{
    return this.GetValue(FieldsFactory.FIELD_ID)
}
HistoricalBrokerMessageGroup.prototype.getTimeStamp = function ()
{
    return this.GetValue(FieldsFactory.FIELD_DATE)
}
HistoricalBrokerMessageGroup.prototype.getProductID = function ()
{
    return this.GetValue(FieldsFactory.FIELD_PRODUCT_ID)
}
HistoricalBrokerMessageGroup.prototype.getSubject = function ()
{
    return this.GetValue(FieldsFactory.FIELD_TITLE)
}
HistoricalBrokerMessageGroup.prototype.getMessage = function ()
{
    return this.GetValue(FieldsFactory.FIELD_TEXT)
}
HistoricalBrokerMessageGroup.prototype.getIsUnread = function ()
{
    return this.GetValue(FieldsFactory.FIELD_IS_UNREAD)
}
HistoricalBrokerMessageGroup.prototype.getResponseCases = function ()
{
    return this.GetValue(FieldsFactory.FIELD_BROKER_MESSAGE_RESPONSE_CASES)
}
HistoricalBrokerMessageGroup.prototype.getDisplayMethod = function ()
{
    return this.GetValue(FieldsFactory.FIELD_DISPLAY_METHOD)
}
HistoricalBrokerMessageGroup.prototype.getCustomButtonsGroups = function ()
{
    return this.GetGroups(FieldsFactory.CUSTOM_BUTTONS_GROUP);
}